var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.926 13.606l1.917 1.577c.157.105.196.244.118.417-.391 1.138-1.024 2.18-1.898 3.126-.13.142-.277.18-.44.111l-2.417-.797a7.354 7.354 0 0 1-1.996 1.103l-.48 2.375a.368.368 0 0 1-.117.204.349.349 0 0 1-.215.102c-.659.117-1.291.176-1.898.176s-1.24-.059-1.898-.176a.349.349 0 0 1-.215-.102.368.368 0 0 1-.118-.204l-.48-2.375a7.055 7.055 0 0 1-1.995-1.103l-2.417.797c-.163.068-.31.031-.44-.111-.874-.946-1.507-1.988-1.898-3.126-.078-.173-.039-.312.118-.417l1.917-1.577a5.907 5.907 0 0 1-.088-1.104c0-.433.03-.8.088-1.103L3.157 9.822c-.157-.105-.196-.244-.118-.418.391-1.137 1.024-2.18 1.898-3.125.13-.142.277-.18.44-.112l2.417.798A7.055 7.055 0 0 1 9.79 5.861l.48-2.374a.368.368 0 0 1 .117-.204.349.349 0 0 1 .215-.102 10.05 10.05 0 0 1 3.796 0c.078.006.15.04.215.102.066.062.105.13.118.204l.48 2.374c.736.272 1.401.64 1.995 1.104l2.417-.798c.163-.068.31-.03.44.112.874.946 1.507 1.988 1.898 3.125.078.174.039.313-.118.418l-1.917 1.577c.059.303.088.67.088 1.103 0 .433-.03.801-.088 1.104zM12.5 16.064c1.037 0 1.922-.348 2.656-1.043.734-.696 1.101-1.536 1.101-2.519 0-.977-.369-1.815-1.106-2.513-.737-.699-1.62-1.048-2.651-1.048-1.037 0-1.922.348-2.656 1.043-.734.696-1.101 1.535-1.101 2.518 0 .99.365 1.83 1.096 2.523.73.693 1.617 1.039 2.661 1.039z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a2b70bc1e6db14270e051d4c9c8fba6d.svg";
export { ForwardRef as ReactComponent };